import React from 'react';

import { NodeProps } from './shared';

export function OrderedListNode({ children }: NodeProps) {
  return <ol>{children}</ol>;
}
